import { useEffect, useState } from "react";
import styled from "styled-components";

import CategoryEditDialog from "./CategoryEditDialog";
import LabelSection from "src/components/core/LabelSection";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { Black, Grey, GreyStroke, White } from "src/styles/color";
import { hexToRgba } from "src/common/color";

import { useDialog } from "src/context/DialogContext";

import { arrayMove } from "@dnd-kit/sortable";
import DraggableBoard, {
  DraggableItem,
} from "src/components/core/DraggableBoard";

import { getCategories, moveCategoryPosition } from "src/api/landingPage";
import font from "src/styles/font";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

S.ItemListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
`;

S.ItemWrapper = styled(DraggableItem)`
  position: relative;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${GreyStroke};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${White};
`;

S.ItemName = styled.span`
  font-size: ${font.size.md};
  font-weight: 500;
  user-select: none;
  white-space: nowrap;
`;

S.ItemAction = styled.div`
  display: flex;
  align-items: center;
`;

const Categories = () => {
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const [categories, setCategories] = useState([]);

  const fetchCategories = async () => {
    try {
      const result = await getCategories();
      setCategories(result);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <S.BoxWrapper>
      <LabelSection
        title="หมวดหมู่สินค้า"
        description={`คุณสามารถแก้ไข้และสลับตำแหน่งได้`}
      >
        <DraggableBoard
          items={categories}
          onDragEnd={async ({ active, over }) => {
            if (active.id !== over?.id) {
              const oldIndex = categories.findIndex(
                (item) => item._id === active.id,
              );
              const newIndex = categories.findIndex(
                (item) => item._id === over.id,
              );

              const newReArranged = arrayMove(categories, oldIndex, newIndex);

              setCategories(newReArranged); // optimistic update

              try {
                await moveCategoryPosition(newReArranged);
              } catch (err) {
                setCategories(categories); // if error, revert to original order
                console.error(err);
              }
            }
          }}
          Components={{
            DroppableParent: ({ items, children }) => {
              return (
                <S.ItemListContainer>{children({ items })}</S.ItemListContainer>
              );
            },
            DraggableItem: (props) => {
              const { items, item: cate, index, ...rest } = props; // Destructuring items to prevent this spreading to html element
              return (
                <S.ItemWrapper {...rest}>
                  <S.ItemAction>
                    <DragIndicatorIcon
                      sx={{
                        color: Grey,
                        marginRight: 1,
                      }}
                    />
                    <S.ItemName>{cate.cate_th}</S.ItemName>
                  </S.ItemAction>
                  <S.ItemAction>
                    <IconButton
                      onClick={() => {
                        openDialog({
                          type: "custom",
                          customDialog: (
                            <CategoryEditDialog
                              onClose={() => closeDialog()}
                              onSuccess={async () => {
                                closeAllDialogs();
                                await fetchCategories();
                              }}
                              initialValue={cate}
                            />
                          ),
                        });
                      }}
                      sx={{
                        width: 32,
                        height: 32,
                      }}
                    >
                      <EditIcon
                        sx={{
                          width: 16,
                          height: 16,
                        }}
                      />
                    </IconButton>
                  </S.ItemAction>
                  {/* <S.SectionItemAction>
                    <IconButton
                      onClick={() => {
                        moveUp(index);
                      }}
                      disabled={index === 0}
                    >
                      <KeyboardArrowUpIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        moveDown(index);
                      }}
                      disabled={index === items?.length - 1}
                    >
                      <KeyboardArrowDownIcon />
                    </IconButton>
                  </S.SectionItemAction> */}
                </S.ItemWrapper>
              );
            },
          }}
        />
      </LabelSection>
    </S.BoxWrapper>
  );
};

export default Categories;
